// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const PhoneSmall: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 15 15"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="15"
            height="15"
            fill="currentColor"
        >
            <path
                d="M321.947574,247.999925 C321.182654,247.993567 320.427526,247.827498 319.730795,247.512328 C317.645377,246.578839 315.791679,245.19813 314.301567,243.468419 C313.211964,242.187119 309.918108,238.305717 311.358387,235.024338 C311.642215,234.390241 312.07119,233.831486 312.610804,233.393024 C313.278134,232.850635 314.2412,232.871819 314.883941,233.443026 L314.934038,233.499278 L316.881546,235.674363 C317.496183,236.238116 317.559548,237.184044 317.025574,237.824448 C317.003872,237.854434 316.978643,237.881713 316.950429,237.905701 L316.061213,238.661981 C316.489872,239.470986 317.013292,240.226307 317.620473,240.912069 C318.29306,241.670442 319.061356,242.338541 319.906134,242.899647 L321.340151,241.649598 C321.929605,241.141661 322.813482,241.180018 323.356543,241.737101 L325.485652,243.905936 C326.122924,244.543079 326.174307,245.558012 325.604631,246.256029 C325.184581,246.778351 324.65713,247.204629 324.057896,247.506078 C323.403456,247.834869 322.680232,248.004087 321.947574,247.999925 Z M313.700407,234.249267 C313.591788,234.247896 313.485874,234.283134 313.399827,234.349311 C313.001541,234.666819 312.683996,235.073707 312.473038,235.536858 C311.715326,237.236925 312.642115,239.630769 315.228356,242.655887 C316.603737,244.256182 318.313724,245.536248 320.238024,246.406035 C321.27296,246.883383 322.465635,246.883383 323.500571,246.406035 C323.935472,246.182893 324.320936,245.87468 324.634008,245.499749 C324.791493,245.290192 324.770117,244.996831 324.583911,244.812222 L322.461065,242.624636 C322.375841,242.541258 322.239446,242.541258 322.154222,242.624636 L320.357004,244.149696 C320.152041,244.326524 319.856395,244.351745 319.62434,244.212199 C318.519909,243.530334 317.523688,242.687675 316.668636,241.7121 C315.886037,240.82784 315.230577,239.839146 314.721127,238.774485 C314.598949,238.519731 314.663121,238.214851 314.877679,238.030706 L316.092524,236.999415 C316.174501,236.86492 316.148118,236.69112 316.029903,236.586899 L315.973544,236.530647 L314.026036,234.361812 C313.931923,234.291298 313.818056,234.251957 313.700407,234.249267 Z"
                transform="translate(-311 -233)"
            />
        </svg>
    );
};

export default React.memo(PhoneSmall);
